module.exports = __webpack_public_path__ + "img/em3.26a603e7.jpg";